export default __webpack_public_path__ + "static/media/close.b502d4ba.svg";